import Notification from './component';

export default Notification;
